import React from 'react';
import { UserRoles } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { Link } from 'react-router-dom';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';

interface IProps {
	to: string;
	translationKey: string;
	roles?: UserRoles[];
}

export const CreateButton: React.FC<IProps> = ({ to, translationKey, roles }) => {
	const hasRole = useRoleAccess(roles ?? []);
	const hasAccess = !roles || hasRole;

	const button = (
		<NewButton iconLeft={<Icon name={IconName.plus} size="lg" />} disabled={!hasAccess} testId="CreateBtn">
			<Text translationNameSpace="listing" translationKey={translationKey} asFragment={true} />
		</NewButton>
	);

	return hasAccess ? <Link to={to}>{button}</Link> : button;
};
